export default __webpack_public_path__ + "img/close-circle.ebad04c7.svg";